import type { TokenType } from "../odata-types.ts";
import { Expression } from "./base/Expression.ts";
import type { FilterExpression } from "./base/types.ts";

export class GroupExpression extends Expression {
    readonly type = "group";

    readonly operator: typeof TokenType.AND | typeof TokenType.OR;
    readonly inner: FilterExpression;

    constructor(operator: typeof TokenType.AND | typeof TokenType.OR, inner: FilterExpression) {
        super();
        this.operator = operator;
        this.inner = inner;
    }

    stringify(): string {
        return `(${this.inner.stringify()})`;
    }

    getKey(): string {
        return `group::${this.operator}::${this.inner.getKey()}`;
    }
}
